import { render, staticRenderFns } from "./gysbjhistory.vue?vue&type=template&id=21ff3118"
import script from "./gysbjhistory.vue?vue&type=script&lang=js"
export * from "./gysbjhistory.vue?vue&type=script&lang=js"
import style0 from "./gysbjhistory.vue?vue&type=style&index=0&id=21ff3118&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports